export default [
    {
        id: 1,
        name: '12 Grain Bread',
        brand: "Lewis Bake Shop",
        expiration: "07/14/2023"
    },
    {
        id: 2,
        name: 'Milk',
        brand: "Great Value",
        expiration: "07/14/2023"
    }
];